<script lang="ts">
  import { onMount, onDestroy } from 'svelte'
  import FullScreenMessage from './FullScreenMessage.svelte'
  import videoStore from '../../stores/video.svelte'

  let canvasRef: HTMLCanvasElement | null = null
  let canvasContext: CanvasRenderingContext2D | null = null
  let requestAF: number | undefined

  function generateNoise(canvasContext: CanvasRenderingContext2D) {
    const imageData = canvasContext.createImageData(
      videoStore.state.playerWidth,
      videoStore.state.playerHeight,
    )
    const data = imageData.data

    for (let i = 0; i < data.length; i += 4) {
      const value = Math.random() * 255
      data[i] = value % 56 // red
      data[i + 1] = value % 56 // green
      data[i + 2] = value % 56 // blue
      data[i + 3] = 255 // alpha
    }

    canvasContext.putImageData(imageData, 0, 0)
  }

  // Animate the noise generation
  function animateStatic() {
    if (
      canvasContext &&
      videoStore.state.playerWidth &&
      videoStore.state.playerHeight
    ) {
      generateNoise(canvasContext)
    }
    requestAF = requestAnimationFrame(animateStatic)
  }

  onMount(() => {
    canvasContext =
      canvasRef && canvasRef !== null ? canvasRef.getContext('2d') : null
    animateStatic()
  })

  onDestroy(() => {
    if (requestAF) {
      cancelAnimationFrame(requestAF)
    }
  })
</script>

<canvas
  bind:this={canvasRef}
  width={`${videoStore.state.playerWidth}px`}
  height={`${videoStore.state.playerHeight}px`}
  class="block absolute w-full h-full top-0 left-0"
></canvas>
<FullScreenMessage class="text-white bg-errorGradient z-10">
  {videoStore.state.errorMessage}
</FullScreenMessage>
